import React from "react";
import styled from "styled-components";

const StyledFieldInput = styled.div`
  &.required .labelContent:after {
    color: #a94442;
    content: " *";
  }

  .inputGroup {
    position: relative;
  }

  .description {
    opacity: 0.6;
    font-size: 0.9em;
  }
`;

const FieldInput = ({ input, meta, label, type, description, required }) => (
  <StyledFieldInput
    className={`form-group${required ? " required" : ""}${
      meta.error && meta.touched ? " has-error" : ""
    }`}
  >
    <label htmlFor={input.name} className="col-sm-3">
      <span className="labelContent">{label}</span>
    </label>
    <div className="col-sm-9 inputGroup">
      <input type={type} className="form-control" id={input.name} {...input} />
      {description && <div className="description">{description}</div>}
      {meta.error && meta.touched && (
        <div className="text-danger">{meta.error}</div>
      )}
    </div>
  </StyledFieldInput>
);

export default FieldInput;
